export const SENTIMENT_CONFIG_API_VERSION = '2025-11-14';

export const sentimentConfigApiPaths = {
  sentimentConfigs: '/sentiment-configs',
  sentimentConfig: (id: string) => `/sentiment-configs/${id}`,
  restoreSentimentConfig: (uuid: string) =>
    `/sentiment-configs/${uuid}/restore`,
  taxonomyAspects: '/relationship-aspect-taxonomies'
};
